import { render, staticRenderFns } from "./BlocoDadosCar.vue?vue&type=template&id=0a028176"
import script from "./BlocoDadosCar.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCar.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCar.vue?vue&type=style&index=0&id=0a028176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports